import apiPaths from '../api-paths';

export default {
  index(query = '') {
    return axios.get(`${ apiPaths.CRM }/mail-templates${ query }`);
  },
}